import { useState } from 'react';
import { Box, ThemeProvider, Typography } from '@mui/material';
import '../../Styles/CategoryStyles.css';
import { theme } from '../../../theme/theme';
import CustomerList from '../../Statefull/CustomerList';
// import AddCustomer from '../Statefull/Customer/AddCustomer';
import EditStoreOwnerModal from '../../Statefull/EditStoreOwnerModal';
import EditCustomer from '../../Statefull/Customer/EditCustomer';
import AddCustomer from '../../Statefull/Customer/AddCustomer';

// import CustomerList from '../Statefull/CustomerList';

const ManageCustomer = () => {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState<'add' | 'edit'>('add');
  const [selectedCustomer, setSelectedCustomer] = useState<any>(null);

  const handleAddCustomer = () => {
    setSelectedCustomer(null);
    setOpen(true);
    setMode('add');
  };

  const handleEditCustomer = (customer: any) => {
    setSelectedCustomer({
      id: customer.id,
      name: customer.customerName,
      email: customer.customerEmail,
      mobileNumber: customer.mobileNumber,
      alternativeMobileNumber: customer.alternativeMobileNumber,
      userAddress: {
        address: customer.userAddress?.address || '',
        latitude: customer.userAddress?.latitude || '',
        longitude: customer.userAddress?.longitude || '',
        label: customer.userAddress?.label || '',
        isDefault: customer.userAddress?.isDefault || false,
      },
      userAddresses: customer.userAddresses || [],
      profileImage: customer.profileImage,
    });
    setOpen(true);
    setMode('edit');
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedCustomer(null);
  };

  return (
    <ThemeProvider theme={theme}>
      <Box>
        <div>
          <Typography variant="h5" fontWeight="bold" mb={2}>
            Customer Management
          </Typography>
          <CustomerList
            editCategory={handleEditCustomer}
            modal={open}
            addCustomer={handleAddCustomer}
          />
          {/* <EditStoreOwnerModal
            open={open}
            onClose={handleClose}
            title={mode === 'add' ? 'Add Customer' : 'Edit Customer'}
          >
            <AddCustomer />
          </EditStoreOwnerModal> */}

          <EditStoreOwnerModal
            open={open}
            onClose={handleClose}
            title={mode === 'add' ? 'Add Customer' : 'Edit Customer'}
          >
            {mode === 'add' ? (
              <AddCustomer onClose={handleClose} />
            ) : (
              <EditCustomer
                initialData={selectedCustomer}
                onClose={handleClose}
              />
            )}
          </EditStoreOwnerModal>
        </div>
      </Box>
    </ThemeProvider>
  );
};

export default ManageCustomer;
